var windowWidth, lazyImages, lazyBackground, lazyIframe, lazyScripts, src, style, datasrc, urls, analytics, s, x, i, j = 0, flag;

function init() {
    if (flag) {
        flag = 0;
        lazyLoadImg();
        lazyLoadBackground();
        lazyLoadIframe();
        load_all_js();
    }
}

function lazyLoadImg() {
    lazyImages.forEach(function (s) {
        s.src = s.dataset.src;
        s.className += " lazyloaded";
    });
}

function lazyLoadBackground() {
    lazyBackground.forEach(function (s) {
        s.style = s.dataset.style;
    });
}

function lazyLoadIframe() {
    lazyIframe.forEach(function (s) {
        s.src = s.dataset.src;
    });
}

function lazyLoadScripts() {
    if (isNaN(j)) {
        j = 0;
    }

    if (j != lazyScripts.length) {
        if (lazyScripts[j] !== undefined && lazyScripts[j].getAttribute("type") === "lazyload2") {
            lazyScripts[j].setAttribute("type", "lazyloaded");

            if (typeof lazyScripts[j].dataset.src !== "undefined") {
                var s = document.createElement("script");
                s.type = "text/javascript";
                s.async = true;
                s.src = lazyScripts[j].dataset.src;

                var x = document.getElementsByTagName("body")[0];
                x.appendChild(s);
                s.onload = function () {
                    j++;
                    lazyLoadScripts();
                };
            } else {
                var scriptContent = lazyScripts[j].innerHTML.trim();
                
                try {
                    var parsedJSON = JSON.parse(scriptContent);
                    // Handle JSON content as needed, for example:
                    window.shopifyAnalytics = parsedJSON;
                } catch (e) {
                    var s = document.createElement("script");
                    s.type = "text/javascript";
                    s.async = true;
                    s.innerHTML = scriptContent;

                    var x = document.getElementsByTagName("body")[0];
                    x.appendChild(s);
                }

                j++;
                lazyLoadScripts();
            }
        } else {
            j++;
            lazyLoadScripts();
        }
    }
}



function lazyLoadCss(t) {
    var s = document.createElement("link");
    s.rel = "stylesheet";
    s.href = t;
    var x = document.getElementsByTagName("head")[0];
    x.appendChild(s);
}

function lazyLoadJS(t) {
    var s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = t;
    var x = document.getElementsByTagName("body")[0];
    x.appendChild(s);
}

function asyncLoad() {}

function load_all_js() {
    lazyLoadCss(assetUrls.bootstrapCss);
    lazyLoadCss(assetUrls.btIconsCss);
    lazyLoadCss(assetUrls.stylesCss);
    lazyLoadCss(assetUrls.navigationMobileCss);
    // Below CSS causing delay in CSS loading and causing conflict with Shopify preload CSS with same filename
    // lazyLoadCss("//cdn.shopify.com/s/files/1/0899/0534/t/49/assets/custom-css.scss.css");
    lazyLoadCss(assetUrls.boldUpsellCss);
    lazyLoadCss(assetUrls.boldUpsellCustomCss);
    lazyLoadCss(assetUrls.boldOptionsCss);
    lazyLoadCss(assetUrls.btSectionCollectionFilterCss);
    // Below CSS causing delay in CSS loading and causing conflict with Shopify preload CSS with same filename
    // lazyLoadCss("//cdn.shopify.com/s/files/1/0899/0534/t/48/assets/custom-css.scss.css");

    setTimeout(function () {
        lazyLoadScripts();
    }, 1000);

    setTimeout(function () {
        var lazyImages = document.querySelectorAll("img.lazy");
        lazyImages.forEach(function (s) {
            s.src = s.dataset.src;
        });
    }, 4000);
}

document.addEventListener("DOMContentLoaded", function () {
    windowWidth = screen.width;
    lazyImages = document.querySelectorAll("img.lazy");
    lazyBackground = document.querySelectorAll(".lazybg");
    lazyIframe = document.querySelectorAll("iframe.lazy");
    lazyScripts = document.querySelectorAll("script[type='lazyload2']");
    i = 0;
    j = 0;
    flag = 1;

    window.addEventListener("scroll", init);
    window.addEventListener("mousemove", init);
    window.addEventListener("touchstart", init);

    setTimeout(init, 9000);
});
